import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Delete from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import DeactivateIcon from '@material-ui/icons/NotInterested';
import ActivateIcon from '@material-ui/icons/PowerSettingsNew';
import { connect } from 'react-redux';
import {
    deleteFuelVendorAccounts,
    toggleFuelVendorStatus
} from 'components/FuelVendor/store/actions';
import { customToolBarStyles } from './CustomToolbarStyles';
import Auxiliary from 'hoc/Auxiliary';
import {
    withStyles,
    MuiThemeProvider,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    DialogTitle,
    Button
} from '@material-ui/core';
import { HEADER_THEME } from './CustomToolbarMuiTheme.js';
import { withRouter } from 'react-router-dom';
import {
    validateDeleteAccess,
    validateWriteAccess
} from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import * as Constants from 'constants/Constants';
import { DIALOG_THEME } from './CustomToolbarMuiTheme';

const EnhancedToolbar = (props) => {
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const {
        classes,
        deleteFuelVendorAccounts,
        sidebarResource,
        selectedFuelAccounts,
        setRowsSelected,
        setCurrentAllSelectedFuelAccounts,
        toggleFuelVendorStatus
    } = props;

    const [isDeleteAccessGranted, setDeleteAccessGranted] = useState(false);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    useEffect(() => {
        setDeleteAccessGranted(
            validateDeleteAccess(
                sidebarResource,
                Constants.FUELVENDOR_RESOURCE,
                Constants.FUELVENDOR_FEATURE
            )
        );
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.FUELVENDOR_RESOURCE,
                Constants.FUELVENDOR_FEATURE
            )
        );
    }, [sidebarResource]);

    const confirmDelete = () => {
        let fuelAccounts = selectedFuelAccounts.map((selectedFuelAccount) => {
            return selectedFuelAccount.id;
        });
        deleteFuelVendorAccounts(fuelAccounts);
        closeDialog();
        setRowsSelected([]);
        setCurrentAllSelectedFuelAccounts([]);
    };

    const handleActivate = (status) => {
        let type = status !== 'activate';
        let selectedIds = [];
        selectedFuelAccounts.map((selectedFuelAccount) => {
            if (selectedFuelAccount.status === type) {
                selectedIds.push(selectedFuelAccount.id);
            }
        });
        if (selectedIds.length > 0) {
            toggleFuelVendorStatus(selectedIds, !type, true);
            setRowsSelected([]);
            setCurrentAllSelectedFuelAccounts([]);
        }
    };
    const handleDelete = (event) => {
        setOpenDeleteDialog(true);
    };

    const closeDialog = () => {
        setOpenDeleteDialog(false);
    };

    const btnOptions = (
        <div style={{ display: 'flex' }}>
            <Tooltip title="Delete">
                <IconButton
                    aria-label="delete_account"
                    onClick={() => handleDelete()}
                    className={classes.iconButtonRoot}
                    disabled={!isDeleteAccessGranted}
                >
                    <Delete className={classes.iconButton} />
                </IconButton>
            </Tooltip>
            <Tooltip title={'Activate'}>
                <IconButton
                    className={classes.iconButton}
                    id={'activate'}
                    disabled={!isWriteAccessGranted}
                    onClick={() => handleActivate('activate')}
                >
                    <ActivateIcon className={classes.deleteIcon} />
                </IconButton>
            </Tooltip>
            <Tooltip title={'Deactivate'}>
                <IconButton
                    className={classes.iconButton}
                    id={'deactivate'}
                    disabled={!isWriteAccessGranted}
                    onClick={() => handleActivate('deactivate')}
                >
                    <DeactivateIcon className={classes.deleteIcon} />
                </IconButton>
            </Tooltip>
        </div>
    );

    return (
        <Auxiliary>
            <MuiThemeProvider theme={HEADER_THEME}>
                <Auxiliary className={classes.actions}>{btnOptions}</Auxiliary>
            </MuiThemeProvider>

            <MuiThemeProvider theme={DIALOG_THEME}>
                <Dialog
                    open={openDeleteDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {'Delete Fuel Card Partner(s)'}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete the selected item(s)?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="cancel" onClick={() => closeDialog()} color="primary">
                            No
                        </Button>
                        <Button
                            id="delete"
                            onClick={() => {
                                confirmDelete();
                            }}
                            color="primary"
                            autoFocus
                        >
                            YES
                        </Button>
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    selectedFuelAccounts: state.fuelVendor.selectedFuelAccounts,
    sidebarResource: state.header.sidebarResource
});

EnhancedToolbar.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withRouter(
    connect(mapStateToProps, {
        deleteFuelVendorAccounts,
        toggleFuelVendorStatus
    })(withStyles(customToolBarStyles)(EnhancedToolbar))
);
